module.exports = __webpack_public_path__ + "static/media/Elf Girl.2ffce838.jpg";